/** Manual interactivo: bots WhatsApp/Telegram + panel /admin de Telegram (Negocio).
 *  Se abre desde Negocio › Configuración › Bot (/negocio/configuracion/bot).
 */

const text = (es, en, pt) => ({ es, en, pt: pt || es });
const go = (labelEs, labelEn, labelPt) => text(labelEs, labelEn, labelPt);
const required = text("Obligatorio", "Required", "Obrigatório");
const spot = (top, left, width, height) => ({ top: `${top}%`, left: `${left}%`, width: `${width}%`, height: `${height}%` });
const band = (top, height = 14, left = 6, width = 88) => spot(top, left, width, height);
const step = (id, nav, title, body, image, points) => ({ id, nav, title, text: body, image, points });
const point = (title, body, area, extra = {}) => ({ title, text: body, spot: area, ...extra });

const IMG = "/guides/steps/negocio-bot.jpg"; // web Bot settings
const TG = (name) => `/guides/steps/${name}.jpg`; // Telegram /admin & client UI

export const botWalkSteps = [
  step(
    "shop",
    text("Canales", "Channels", "Canais"),
    text("WhatsApp y Telegram por separado", "WhatsApp and Telegram separately", "WhatsApp e Telegram separados"),
    text(
      "En esta pantalla enciendes la tienda guiada. El bot vende el catálogo, precios y stock de Negocio. Cada canal es independiente: solo WhatsApp, solo Telegram o ambos.",
      "This screen turns on the guided store. The bot sells Negocio catalog, prices and stock. Each channel is independent.",
      "Nesta tela você liga a loja guiada. Cada canal é independente."
    ),
    IMG,
    [
      point(
        text("Bot activo en WhatsApp", "Bot active on WhatsApp", "Bot ativo no WhatsApp"),
        text(
          "Atiende en la conexión WhatsApp vinculada (Conexiones › estado Conectada). El cliente escribe al número y ve el menú guiado. Sin conexión activa no responde.",
          "Serves on the linked WhatsApp connection (Connections › Connected). Without an active session it will not answer.",
          "Atende na conexão WhatsApp vinculada. Sem conexão ativa não responde."
        ),
        band(22, 8),
        { to: "/connections", toLabel: go("Ir a Conexiones", "Open Connections", "Abrir Conexões"), required }
      ),
      point(
        text("Bot activo en Telegram", "Bot active on Telegram", "Bot ativo no Telegram"),
        text(
          "Usa el token de @BotFather. Al Guardar, el sistema inicia el bot. Sin token válido no responde. Más abajo: «Probar bot Telegram».",
          "Uses the @BotFather token. On Save the system starts the bot. Test it with Test Telegram bot.",
          "Usa o token do @BotFather. Ao Salvar o sistema inicia o bot."
        ),
        band(30, 8),
        { required }
      ),
      point(
        text("Entretenimiento TMDB", "TMDB entertainment", "Entretenimento TMDB"),
        text(
          "Los interruptores de arriba permiten /entretenimiento o /tendencias en cada canal. La clave TMDB se configura en Integraciones, no aquí.",
          "The switches above allow /entertainment on each channel. The TMDB key is in Integrations.",
          "Os interruptores permitem /entretenimento. A chave TMDB fica em Integrações."
        ),
        band(10, 10),
        { to: "/negocio/configuracion/integraciones", toLabel: go("Abrir Integraciones", "Open Integrations", "Abrir Integrações") }
      ),
    ]
  ),

  step(
    "whatsapp",
    text("WhatsApp", "WhatsApp", "WhatsApp"),
    text("Cómo opera el bot de WhatsApp", "How the WhatsApp bot works", "Como opera o bot do WhatsApp"),
    text(
      "El bot de WhatsApp no usa token de BotFather: usa la misma sesión que ya conectaste. El menú es numérico o con botones interactivos según tu conexión.",
      "The WhatsApp bot does not use a BotFather token: it uses the connected session. The menu is numeric or interactive buttons.",
      "O bot WhatsApp usa a sessão conectada. O menu é numérico ou com botões interativos."
    ),
    IMG,
    [
      point(
        text("Conexión", "Connection", "Conexão"),
        text(
          "1) Conexiones → agrega/vincula WhatsApp. 2) Espera Conectada. 3) Activa «Bot activo en WhatsApp» aquí y Guarda. 4) Escríbete desde otro número y pide el menú.",
          "1) Connections → link WhatsApp. 2) Wait Connected. 3) Enable Bot on WhatsApp here and Save. 4) Message yourself from another number.",
          "1) Conexões → vincule WhatsApp. 2) Aguarde Conectada. 3) Ative o bot e Salve. 4) Escreva de outro número."
        ),
        band(20, 14),
        { to: "/connections", toLabel: go("Abrir Conexiones", "Open Connections", "Abrir Conexões"), required }
      ),
      point(
        text("Menú del cliente (WA)", "Customer menu (WA)", "Menu do cliente (WA)"),
        text(
          "Responde con el número (1 Tienda, 2 Servicios…) o toca los botones si tu línea los muestra. Mismo inventario que Telegram: productos, precios y stock de Negocio.",
          "Reply with the number or tap buttons if shown. Same inventory as Telegram.",
          "Responda com o número ou toque os botões. Mesmo inventário do Telegram."
        ),
        band(36, 12)
      ),
      point(
        text("Alertas al admin", "Admin alerts", "Alertas ao admin"),
        text(
          "Pedidos nuevos, pagos por validar y escalados de soporte llegan al WhatsApp del admin (campo más abajo). No confundas ese número con el de la conexión de venta.",
          "New orders, payments to review and support escalations go to Admin WhatsApp below.",
          "Pedidos, pagamentos e suporte vão ao WhatsApp do admin."
        ),
        band(50, 12)
      ),
    ]
  ),

  step(
    "options",
    text("Opciones", "Options", "Opções"),
    text("Menú, monedero, promo y calificación", "Menu, wallet, promo and rating", "Menu, carteira, promo e avaliação"),
    text(
      "Estos interruptores cambian el menú del cliente en WhatsApp y Telegram. Actívalos solo si ofreces esa función en Fidelización / Ajustes.",
      "These switches change the customer menu on both channels. Enable only if you offer that feature.",
      "Esses interruptores mudam o menu do cliente. Ative só se oferecer a função."
    ),
    IMG,
    [
      point(
        text("Atajo PROMO", "PROMO shortcut", "Atalho PROMO"),
        text(
          "Muestra ✨ Promo en el menú. Las ofertas reales se arman en Fidelización o en /admin › Promos automáticas (Telegram).",
          "Shows ✨ Promo. Real offers are in Loyalty or /admin › Auto promos.",
          "Mostra ✨ Promo. Ofertas reais em Fidelização ou /admin › Promos."
        ),
        band(38, 7)
      ),
      point(
        text("Solo menú guiado", "Guided menu only", "Só menu guiado"),
        text(
          "El cliente compra con botones. Si escribe texto libre, el bot pide usar el menú. Desactívalo solo si el agente IA debe leer texto libre.",
          "Customer buys with buttons. Turn off only if the AI agent should read free text.",
          "O cliente compra com botões. Desative só se o agente IA deve ler texto livre."
        ),
        band(45, 7)
      ),
      point(
        text("Monedero y calificación", "Wallet and rating", "Carteira e avaliação"),
        text(
          "Monedero: muestra 💳 y permite pagar/renovar con saldo. Calificación: tras entregar, pide nota 1–3. Ambos deben coincidir con Fidelización.",
          "Wallet: 💳 pay/renew with balance. Rating: asks 1–3 after delivery. Align with Loyalty.",
          "Carteira e avaliação devem coincidir com Fidelização."
        ),
        band(52, 10),
        { to: "/negocio/configuracion/fidelizacion", toLabel: go("Ir a Fidelización", "Open Loyalty", "Abrir Fidelização") }
      ),
    ]
  ),

  step(
    "identity",
    text("Identidad", "Identity", "Identidade"),
    text("Nombre de tienda y token Telegram", "Store name and Telegram token", "Nome da loja e token Telegram"),
    text(
      "El nombre sale en la bienvenida y en la entrega. El token de Telegram se guarda: el campo vuelve vacío y no se vuelve a mostrar.",
      "The name appears in the welcome and delivery. The Telegram token is stored; the field stays empty.",
      "O nome sai na boas-vindas. O token fica salvo; o campo volta vazio."
    ),
    IMG,
    [
      point(
        text("Nombre de la tienda", "Store name", "Nome da loja"),
        text("Ejemplo: StreamDG Shop. Evita dejarlo vacío: el bot se presenta con ese nombre.", "Example: StreamDG Shop. Do not leave empty.", "Exemplo: StreamDG Shop. Não deixe vazio."),
        band(62, 8),
        { required }
      ),
      point(
        text("Token @BotFather (paso a paso)", "Token @BotFather (step by step)", "Token @BotFather (passo a passo)"),
        text(
          "1) Abre @BotFather en Telegram. 2) /newbot → nombre y @usuario. 3) Copia el token. 4) Pégalo aquí. 5) Guarda. 6) Pulsa Probar bot Telegram. Si sale bien, verás el @usuario.",
          "1) @BotFather → /newbot. 2) Paste token. 3) Save. 4) Test Telegram bot.",
          "1) @BotFather → /newbot. 2) Cole o token. 3) Salve. 4) Testar."
        ),
        band(70, 12),
        { required }
      ),
    ]
  ),

  step(
    "admins",
    text("Admin y colas", "Admin and queues", "Admin e filas"),
    text("Quién recibe alertas y quién abre /admin", "Who gets alerts and who opens /admin", "Quem recebe alertas e quem abre /admin"),
    text(
      "Las alertas van al WhatsApp del admin. El panel /admin del bot de Telegram solo lo abren los usuarios listados en Usuario Telegram del admin.",
      "Alerts go to admin WhatsApp. The Telegram /admin panel is only for listed Telegram users.",
      "Alertas vão ao WhatsApp do admin. O /admin do Telegram é só para os usuários listados."
    ),
    IMG,
    [
      point(
        text("WhatsApp del admin", "Admin WhatsApp", "WhatsApp do admin"),
        text("Recibe pedidos nuevos, pagos por validar y escalados. Número con país, sin espacios raros.", "Receives new orders, payments to review and escalations.", "Recebe pedidos, pagamentos e suporte."),
        band(78, 8),
        { required }
      ),
      point(
        text("Usuario Telegram del admin", "Admin Telegram user", "Usuário Telegram do admin"),
        text(
          "Sin @. Ejemplo: miusuario. Varios separados por coma. Esos usuarios escriben /admin, /config o /panel y abren Personalización, Campañas y Promos.",
          "Without @. Comma-separated. Those users open /admin in the bot.",
          "Sem @. Separados por vírgula. Abrem /admin no bot."
        ),
        band(86, 8),
        { required }
      ),
      point(
        text("Departamentos Ventas y Soporte", "Sales and Support departments", "Departamentos Vendas e Suporte"),
        text(
          "Cuando el cliente pide un asesor o reporta una falla, el ticket cae ahí. Créalos en Departamentos si la lista está vacía.",
          "When the customer asks for an advisor or reports a fault, the ticket goes there.",
          "Quando o cliente pede um atendente, o ticket vai para esse departamento."
        ),
        band(94, 8),
        { to: "/queues", toLabel: go("Ir a Departamentos", "Open Departments", "Abrir Departamentos") }
      ),
    ]
  ),

  step(
    "welcome",
    text("Bienvenida", "Welcome", "Boas-vindas"),
    text("Primer mensaje del bot", "Bot first message", "Primeira mensagem do bot"),
    text(
      "Es lo primero que ve el cliente en /start (Telegram) o al abrir el menú (WhatsApp). Puedes adjuntar imagen y usar {{nombre}} o {{nombre_cliente}}.",
      "First thing on /start (Telegram) or the menu (WhatsApp). You can attach an image and use {{nombre}}.",
      "É o primeiro em /start ou no menu. Pode anexar imagem e usar {{nombre}}."
    ),
    IMG,
    [
      point(
        text("Texto y media", "Text and media", "Texto e mídia"),
        text(
          "1) Escribe el saludo. 2) Adjunta foto si quieres. 3) Revisa la vista previa. 4) Guarda. 5) En Telegram escribe /start desde tu cuenta. También se edita en /admin › Personalización › Bienvenida.",
          "1) Write greeting. 2) Attach photo. 3) Preview. 4) Save. 5) Test /start. Also editable in /admin › Welcome.",
          "1) Escreva. 2) Anexe foto. 3) Prévia. 4) Salve. 5) Teste /start."
        ),
        band(55, 18)
      ),
    ]
  ),

  step(
    "customer-menu",
    text("Menú cliente", "Customer menu", "Menu cliente"),
    text("Comandos y botones del cliente", "Customer commands and buttons", "Comandos e botões do cliente"),
    text(
      "Telegram: botones o comandos. WhatsApp: menú numérico / botones. Ambos venden el mismo inventario de Negocio.",
      "Telegram: buttons or commands. WhatsApp: numeric/interactive menu. Same Negocio inventory.",
      "Telegram: botões ou comandos. WhatsApp: menu. Mesmo inventário."
    ),
    TG("tg-menu"),
    [
      point(
        text("Comandos Telegram", "Telegram commands", "Comandos Telegram"),
        text(
          "/start menú · /tienda · /servicios · /renovar · /saldo · /pagos · /invitar · /soporte · /menu · /productos · /wallet · /promos (volver a recibir promos) · /entretenimiento o /tendencias (si TMDB está on).",
          "/start · /tienda · /servicios · /renovar · /saldo · /pagos · /invitar · /soporte · /promos · /entretenimiento if TMDB is on.",
          "/start · /tienda · /servicios · /renovar · /saldo · /pagos · /invitar · /soporte · /promos."
        ),
        band(18, 16)
      ),
      point(
        text("Botones del menú", "Menu buttons", "Botões do menu"),
        text(
          "🛍️ Tienda · 📝 Pedido especial · 📺 Servicios · 🔄 Renovar · 📅 Vencen · 🔑 Códigos · 💳 Monedero · ⭐ Puntos · 🆘 Soporte · 📜 Historial · 💰 Métodos · ✨ Promo · 🎁 Invita · 🌐 Idioma · 💬 Asesor. El admin además ve ⚙️ Configuración.",
          "🛍️ Shop · special order · services · renew · due · codes · wallet · points · support · history · methods · promo · invite · language · advisor. Admins also see ⚙️ Settings.",
          "🛍️ Loja · pedido · serviços · renovar · vencem · códigos · carteira · pontos · suporte · histórico · métodos · promo · indicar · idioma."
        ),
        band(36, 16)
      ),
      point(
        text("Personalizar etiquetas", "Customize labels", "Personalizar rótulos"),
        text(
          "Los textos y emojis de esos botones se cambian en Telegram: /admin › 🎨 Personalización › 🔘 Botones (paso 12).",
          "Labels/emojis are changed in Telegram: /admin › Customization › Buttons (step 12).",
          "Textos/emojis mudam em /admin › Personalização › Botões."
        ),
        band(54, 10)
      ),
    ]
  ),

  step(
    "customer-buy",
    text("Compra", "Purchase", "Compra"),
    text("Recorrido de compra paso a paso", "Purchase flow step by step", "Fluxo de compra passo a passo"),
    text(
      "Pruébalo tú mismo antes de anunciarlo a clientes.",
      "Test it yourself before announcing it.",
      "Teste você mesmo antes de anunciar."
    ),
    TG("tg-shop"),
    [
      point(
        text("1 Catálogo", "1 Catalog", "1 Catálogo"),
        text("Tienda → categoría → plan/modalidad (cuenta completa o por perfil) → ficha con precio, stock, modalidad y descripción.", "Shop → category → plan (full account or profile) → card with price, stock and modality.", "Loja → categoria → plano → ficha."),
        band(16, 10)
      ),
      point(
        text("2 Datos si hacen falta", "2 Extra data if needed", "2 Dados se precisar"),
        text("Algunos productos piden correo del miembro o un ID externo antes del pago. El bot lo solicita en el chat.", "Some products ask for member email or an external ID before payment.", "Alguns produtos pedem e-mail ou ID externo."),
        band(28, 10)
      ),
      point(
        text("3 Pago", "3 Payment", "3 Pagamento"),
        text("Elige método (o paga con saldo). «Ya pagué» + comprobante, o Binance si aplica. El admin recibe la alerta en WhatsApp.", "Pick method (or wallet). Paid + proof, or Binance. Admin gets WhatsApp alert.", "Escolhe método ou carteira. Admin recebe alerta."),
        band(40, 10)
      ),
      point(
        text("4 Entrega y calificación", "4 Delivery and rating", "4 Entrega e avaliação"),
        text("Al confirmar el pago se entrega con la plantilla de Mensajes. Luego puede pedir calificación 1–3 si está activa.", "After payment confirmation, delivery uses the Messages template. Then may ask for 1–3 rating.", "Após confirmar, entrega com o modelo de Mensagens."),
        band(52, 12),
        { to: "/negocio/configuracion/mensajes", toLabel: go("Plantilla de entrega", "Delivery template", "Modelo de entrega") }
      ),
    ]
  ),

  step(
    "customer-account",
    text("Cuenta", "Account", "Conta"),
    text("Servicios, renovar, saldo y soporte", "Services, renew, balance and support", "Serviços, renovar, saldo e suporte"),
    text(
      "Después de la primera compra, el cliente gestiona su cartera desde el mismo bot.",
      "After the first purchase, the customer manages their portfolio in the same bot.",
      "Depois da primeira compra, gerencia a carteira no mesmo bot."
    ),
    TG("tg-menu"),
    [
      point(
        text("Servicios / Renovar / Vencen", "Services / Renew / Due", "Serviços / Renovar / Vencem"),
        text("Lista lo activo, renueva el mismo servicio (no un perfil nuevo) y ve lo por vencer. Renovar vuelve al flujo de pago.", "Lists active services, renews the same service, shows what is due.", "Lista ativos, renova o mesmo serviço e mostra o que vence."),
        band(18, 12)
      ),
      point(
        text("Códigos y soporte", "Codes and support", "Códigos e suporte"),
        text("🔑 consulta códigos del correo de la cuenta (si configuraste Códigos). 🆘 falla o asesor → ticket en departamento Soporte. 💬 Asesor → Ventas.", "🔑 mailbox codes if configured. 🆘 support ticket. 💬 advisor → Sales.", "🔑 códigos. 🆘 suporte. 💬 atendente → Vendas."),
        band(32, 12),
        { to: "/negocio/configuracion/codigos", toLabel: go("Consulta de códigos", "Code lookup", "Consulta de códigos") }
      ),
      point(
        text("Monedero, puntos e invitar", "Wallet, points and invite", "Carteira, pontos e indicar"),
        text("Saldo, recargas y pago con saldo. ⭐ Puntos si el sistema de puntos está on. Invitar usa referidos de Fidelización.", "Balance, top-ups, points if enabled, referrals if Loyalty has them on.", "Saldo, pontos e indicação se ativos."),
        band(46, 12),
        { to: "/negocio/configuracion/fidelizacion", toLabel: go("Fidelización", "Loyalty", "Fidelização") }
      ),
    ]
  ),

  step(
    "tg-admin",
    text("Panel /admin", "/admin panel", "Painel /admin"),
    text("Cómo abrir la configuración en Telegram", "How to open settings in Telegram", "Como abrir a configuração no Telegram"),
    text(
      "Las opciones avanzadas del bot de Telegram se configuran dentro de Telegram, no en esta página web. Solo los admins listados en el paso 5 pueden entrar.",
      "Advanced Telegram options are inside Telegram, not on this web page. Only admins from step 5 can enter.",
      "As opções avançadas ficam no Telegram. Só os admins do passo 5 entram."
    ),
    TG("tg-admin"),
    [
      point(
        text("Entrar (paso a paso)", "Enter (step by step)", "Entrar (passo a passo)"),
        text(
          "1) Abre tu bot en Telegram con la cuenta admin. 2) Escribe /admin (también /config o /panel). 3) O toca ⚙️ Configuración en el menú. Si no eres admin, el bot no abre el panel.",
          "1) Open the bot as admin. 2) Type /admin (/config /panel). 3) Or tap ⚙️ Settings. Non-admins cannot open it.",
          "1) Abra o bot como admin. 2) /admin. 3) Ou ⚙️. Quem não é admin não entra."
        ),
        band(20, 14),
        { required }
      ),
      point(
        text("Inicio del panel", "Panel home", "Início do painel"),
        text(
          "🎨 Personalización · 📣 Campañas · 🤖 Promos automáticas · 📊 Audiencia · 🏠 Menú del cliente. Los pasos siguientes recorren cada opción.",
          "🎨 Customization · 📣 Campaigns · 🤖 Auto promos · 📊 Audience · 🏠 Customer menu.",
          "🎨 Personalização · 📣 Campanhas · 🤖 Promos · 📊 Audiência · 🏠 Menu."
        ),
        band(38, 14)
      ),
    ]
  ),

  step(
    "tg-custom",
    text("Personalizar", "Customize", "Personalizar"),
    text("Menú de personalización", "Customization menu", "Menu de personalização"),
    text(
      "/admin → 🎨 Personalización. Ahí entras a Mensajes, Botones, Productos y Bienvenida.",
      "/admin → 🎨 Customization: Messages, Buttons, Products and Welcome.",
      "/admin → 🎨 Personalização: Mensagens, Botões, Produtos e Boas-vindas."
    ),
    TG("tg-custom"),
    [
      point(
        text("📝 Mensajes", "📝 Messages", "📝 Mensagens"),
        text("Plantillas del bot (pie del menú, catálogo, ficha, orden, pago, entrega, calificación, soporte, sin stock, aviso de botones). Detalle en el paso 12.", "Bot templates. Detail in step 12.", "Modelos do bot. Detalhe no passo 12."),
        band(18, 10)
      ),
      point(
        text("🔘 Botones · 🛍️ Productos · 👋 Bienvenida", "🔘 Buttons · 🛍️ Products · 👋 Welcome", "🔘 Botões · 🛍️ Produtos · 👋 Boas-vindas"),
        text(
          "Botones: texto/emoji/color (paso 13). Productos: nombre visible, descripción y Visible en bot. Bienvenida: igual que el campo de esta página web.",
          "Buttons: label/emoji/color (step 13). Products: display name, description, botSellable. Welcome: same as this web field.",
          "Botões: texto/emoji/cor. Produtos: nome, descrição, visível no bot. Boas-vindas: igual à web."
        ),
        band(32, 14)
      ),
    ]
  ),

  step(
    "tg-texts",
    text("Mensajes", "Messages", "Mensagens"),
    text("Cada plantilla editable del bot", "Each editable bot template", "Cada modelo editável do bot"),
    text(
      "/admin → Personalización → 📝 Mensajes. Toca una → ✏️ Editar → envía el texto nuevo → o ↩️ Restaurar.",
      "/admin → Customization → 📝 Messages. Open → Edit → send new text → or Restore.",
      "/admin → Personalização → 📝 Mensagens. Abra → Editar → envie o texto → ou Restaurar."
    ),
    TG("tg-texts"),
    [
      point(
        text("Plantillas 1–7", "Templates 1–7", "Modelos 1–7"),
        text(
          "Pie del menú · Encabezado del catálogo · Pie de categoría · Pie de la ficha · Línea de entrega automática · Título del resumen de orden · Pie del resumen (elegir pago).",
          "Menu footer · Catalog header · Category footer · Product card footer · Auto delivery line · Order summary title · Order summary footer.",
          "Rodapé do menu · Cabeçalho do catálogo · Rodapé da categoria · Rodapé da ficha · Entrega automática · Título do resumo · Rodapé do resumo."
        ),
        band(18, 14)
      ),
      point(
        text("Plantillas 8–14", "Templates 8–14", "Modelos 8–14"),
        text(
          "Pago verificado · Orden entregada · Título de datos entregados · Pregunta de calificación · Menú de soporte · Sin stock · Aviso «usa los botones».",
          "Payment verified · Order delivered · Delivered data title · Rating question · Support menu · Out of stock · Use the buttons notice.",
          "Pagamento verificado · Pedido entregue · Dados entregues · Avaliação · Suporte · Sem estoque · Use os botões."
        ),
        band(36, 14)
      ),
    ]
  ),

  step(
    "tg-buttons",
    text("Botones", "Buttons", "Botões"),
    text("Cada botón del menú del cliente", "Each customer menu button", "Cada botão do menu do cliente"),
    text(
      "/admin → Personalización → 🔘 Botones. Toca uno → ✏️ Texto y emoji · 🎨 Color (normal/azul/verde/rojo) · ↩️ Restaurar.",
      "/admin → Customization → 🔘 Buttons. Open one → Edit text/emoji · Color · Restore.",
      "/admin → Personalização → 🔘 Botões. Abra → Texto/emoji · Cor · Restaurar."
    ),
    TG("tg-buttons"),
    [
      point(
        text("Botones principales", "Main buttons", "Botões principais"),
        text(
          "Tienda · Servicios · Renovar · Vencen · Códigos · Monedero · Puntos · Soporte · Historial · Métodos de pago · Promo · Menú.",
          "Shop · Services · Renew · Due · Codes · Wallet · Points · Support · History · Methods · Promo · Menu.",
          "Loja · Serviços · Renovar · Vencem · Códigos · Carteira · Pontos · Suporte · Histórico · Métodos · Promo · Menu."
        ),
        band(20, 14)
      ),
      point(
        text("Botones de flujo", "Flow buttons", "Botões de fluxo"),
        text(
          "Asesor · Ya pagué · Cancelar. Cambia solo la etiqueta visible; la acción sigue siendo la misma.",
          "Advisor · Paid · Cancel. Only the visible label changes; the action stays the same.",
          "Atendente · Já paguei · Cancelar. Só o rótulo muda."
        ),
        band(38, 12)
      ),
    ]
  ),

  step(
    "tg-campaigns",
    text("Campañas", "Campaigns", "Campanhas"),
    text("Campañas manuales desde el bot", "Manual campaigns from the bot", "Campanhas manuais pelo bot"),
    text(
      "/admin → 📣 Campañas. Aviso puntual a usuarios del bot y/o grupos-canales activos.",
      "/admin → 📣 Campaigns. One-off notice to bot users and/or active groups/channels.",
      "/admin → 📣 Campanhas. Aviso pontual a usuários e/ou grupos."
    ),
    TG("tg-campaigns"),
    [
      point(
        text("Nueva campaña (4 pasos)", "New campaign (4 steps)", "Nova campanha (4 passos)"),
        text(
          "1) Contenido (texto/foto/video/doc). 2) Botones: Tienda, ninguno, o «Texto | url». 3) Audiencia: todos / activos / vencidos / sin compra / chats / todos+chats. 4) Revisar: silencio, proteger, fijar, intervalo, repetir → Prueba → Enviar o Programar (ej. 28/10 18:30).",
          "1) Content. 2) Buttons. 3) Audience. 4) Review → Test → Send or Schedule.",
          "1) Conteúdo. 2) Botões. 3) Audiência. 4) Revisar → Teste → Enviar ou Agendar."
        ),
        band(16, 18)
      ),
      point(
        text("Mis campañas", "My campaigns", "Minhas campanhas"),
        text(
          "Ver · Probar · Enviar de nuevo · Cancelar programación · Eliminar. También lista campañas de Telegram del panel Watoolx (Grupos) y permite pararlas.",
          "View · Test · Resend · Cancel · Delete. Also lists Watoolx panel Telegram campaigns and can stop them.",
          "Ver · Testar · Reenviar · Cancelar · Apagar. Também lista campanhas do painel Watoolx."
        ),
        band(38, 12),
        { to: "/groups", toLabel: go("Campañas de grupos (panel)", "Group campaigns (panel)", "Campanhas de grupos (painel)") }
      ),
    ]
  ),

  step(
    "tg-chats",
    text("Grupos", "Groups", "Grupos"),
    text("Grupos, canales y temas", "Groups, channels and topics", "Grupos, canais e tópicos"),
    text(
      "Campañas › 📢 Grupos y canales (también desde Promos › Canales). Eliges dónde publica el bot o tu cuenta conectada.",
      "Campaigns › 📢 Groups and channels (also Promos › Channels). Choose where the bot or connected account publishes.",
      "Campanhas › 📢 Grupos e canais. Escolha onde o bot ou a conta conectada publica."
    ),
    TG("tg-chats"),
    [
      point(
        text("Activar destinos", "Enable destinations", "Ativar destinos"),
        text(
          "🤖 = el bot está en el grupo y publica él. 👤 = publica tu cuenta de Telegram conectada en Watoolx. Toca el nombre para activar/pausar. «Actualizar desde cuenta conectada» sincroniza los grupos.",
          "🤖 = bot in the group. 👤 = connected Watoolx account. Tap to enable/pause. Refresh syncs groups.",
          "🤖 = bot no grupo. 👤 = conta conectada. Toque para ativar. Atualizar sincroniza."
        ),
        band(18, 14),
        { to: "/connections", toLabel: go("Conexión Telegram", "Telegram connection", "Conexão Telegram") }
      ),
      point(
        text("Temas (foros)", "Topics (forums)", "Tópicos (fóruns)"),
        text(
          "Toca 🧵 → marca Chat general y/o temas. En el grupo: /tema · /tema_quitar · /tema_general. Campañas y promos salen en cada tema marcado.",
          "Tap 🧵 → mark General and/or topics. In-group: /tema · /tema_quitar · /tema_general.",
          "Toque 🧵. No grupo: /tema · /tema_quitar · /tema_general."
        ),
        band(36, 14)
      ),
    ]
  ),

  step(
    "tg-audience",
    text("Audiencia", "Audience", "Audiência"),
    text("Estadísticas del bot", "Bot statistics", "Estatísticas do bot"),
    text(
      "/admin → 📊 Audiencia. Solo lectura: te dice a cuántos puedes llegar antes de lanzar una campaña o una promo.",
      "/admin → 📊 Audience. Read-only reach before a campaign or promo.",
      "/admin → 📊 Audiência. Alcance antes de campanha ou promo."
    ),
    TG("tg-audience"),
    [
      point(
        text("Qué muestra", "What it shows", "O que mostra"),
        text(
          "Usuarios que han escrito · Activos últimos 30 días · Opt-out de promociones · Bloquearon el bot · Grupos/canales activos.",
          "Users who wrote · Active last 30 days · Promo opt-out · Blocked the bot · Active groups/channels.",
          "Usuários · Ativos 30 dias · Opt-out · Bloquearam · Grupos ativos."
        ),
        band(24, 16)
      ),
    ]
  ),

  step(
    "tg-promos",
    text("Promos auto", "Auto promos", "Promos auto"),
    text("Cada interruptor de promociones automáticas", "Each automatic promotion switch", "Cada interruptor das promoções automáticas"),
    text(
      "/admin → 🤖 Promociones automáticas. El motor respeta usuarios activos (días), máximo por día y horario silencioso.",
      "/admin → 🤖 Automatic promotions. Respects active days, max/day and quiet hours.",
      "/admin → 🤖 Promoções automáticas."
    ),
    TG("tg-promos"),
    [
      point(
        text("Activar · Stock · Nuevos · Bajas · Interés", "On · Stock · New · Drops · Interest", "Ligar · Stock · Novos · Quedas · Interesse"),
        text(
          "✅/⛔ Activar todo. 📦 Stock (+ ✏️ texto). 🆕 Productos nuevos. 🔥 Bajas de precio. 🎯 Segmentar: stock/bajas solo a quien miró esa categoría; los nuevos van a todos.",
          "Master on/off. 📦 Stock (+ text). 🆕 New. 🔥 Drops. 🎯 Segment interest.",
          "Ligar/desligar. 📦 Stock. 🆕 Novos. 🔥 Quedas. 🎯 Interesse."
        ),
        band(14, 14)
      ),
      point(
        text("Canales · Destacado · Límites", "Channels · Spotlight · Limits", "Canais · Destaque · Limites"),
        text(
          "📢 Canales: lista de destinos + «Publicar promos: Sí» + sincronizar cuenta. 🌟 Destacado: cada 12/24/48/72/168 h o No (+ ✏️ texto). 📆 Activos 7–180 d. 🔢 Máx/día 1–5. 🌙 No enviar (ej. 22:00–7:00).",
          "📢 Channels list + publish on. 🌟 Spotlight interval + text. 📆 Active days. 🔢 Max/day. 🌙 Quiet hours.",
          "📢 Canais. 🌟 Destaque. 📆 Dias. 🔢 Máx/dia. 🌙 Horário quieto."
        ),
        band(32, 14)
      ),
      point(
        text("Probar · Métricas · Msjs", "Test · Metrics · Msgs", "Testar · Métricas · Msgs"),
        text(
          "🧪 Probar producto destacado. 📊 Métricas 7/30 días (enviados, clics, ventas). 💬 Mensajes promocionales: paso 18.",
          "🧪 Test spotlight. 📊 Metrics 7/30. 💬 Promo messages: step 18.",
          "🧪 Testar destaque. 📊 Métricas. 💬 Mensagens: passo 18."
        ),
        band(50, 12)
      ),
    ]
  ),

  step(
    "tg-promo-msgs",
    text("Msjs promo", "Promo msgs", "Msgs promo"),
    text("Mensajes promocionales programados", "Scheduled promo messages", "Mensagens promocionais agendadas"),
    text(
      "Promos → 💬 Mensajes promocionales. Avisos propios cada N horas, aparte de stock/nuevos/destacado.",
      "Promos → 💬 Promo messages. Your own notices every N hours, separate from stock/new/spotlight.",
      "Promos → 💬 Mensagens. Avisos próprios a cada N horas."
    ),
    TG("tg-promo-msgs"),
    [
      point(
        text("Crear (paso a paso)", "Create (step by step)", "Criar (passo a passo)"),
        text(
          "1) ➕ Nuevo. 2) Envía contenido. 3) Botones: tienda / ninguno / personalizados. 4) Frecuencia 24/48/72/120/168 h. 5) Pausar, probar o eliminar cuando quieras.",
          "1) ➕ New. 2) Content. 3) Buttons. 4) Frequency. 5) Pause, test or delete.",
          "1) ➕ Novo. 2) Conteúdo. 3) Botões. 4) Frequência. 5) Pausar, testar ou apagar."
        ),
        band(22, 14)
      ),
      point(
        text("Opt-out del cliente", "Customer opt-out", "Opt-out do cliente"),
        text(
          "Cada promo lleva «No recibir promociones». Para volver: el cliente escribe /promos. No fuerces el reingreso.",
          "Each promo has Do not receive promotions. To come back: /promos.",
          "Cada promo tem Não receber. Para voltar: /promos."
        ),
        band(40, 12)
      ),
    ]
  ),

  step(
    "check",
    text("Cierre", "Wrap-up", "Fecho"),
    text("Lista de comprobación", "Checklist", "Lista de verificação"),
    text(
      "Antes de anunciarlo a clientes, marca estos puntos.",
      "Before announcing to customers, check these points.",
      "Antes de anunciar, confira estes pontos."
    ),
    IMG,
    [
      point(
        text("Panel web (esta pantalla)", "Web panel (this screen)", "Painel web (esta tela)"),
        text(
          "Canal(es) on · WhatsApp Conectada si aplica · token Telegram probado · nombre · admin WA/TG · colas · bienvenida · monedero/promo/calificación según tu oferta · Guardar.",
          "Channel(s) on · WhatsApp Connected if used · Telegram token tested · name · admins · queues · welcome · toggles · Save.",
          "Canal(is) on · WhatsApp Conectada · token testado · nome · admins · filas · boas-vindas · Salvar."
        ),
        band(18, 12)
      ),
      point(
        text("Telegram /admin", "Telegram /admin", "Telegram /admin"),
        text(
          "Personalización revisada · destino de grupo si vas a publicar · promos on solo con textos/límites · una prueba de campaña y de destacado · audiencia revisada.",
          "Customization reviewed · group destination if publishing · promos only with texts/limits · one campaign and spotlight test · audience checked.",
          "Personalização · destino de grupo · promos com textos/limites · um teste · audiência."
        ),
        band(34, 12)
      ),
      point(
        text("Como cliente", "As customer", "Como cliente"),
        text(
          "Desde otra cuenta: /start → comprar (cancelar al final) → menú completo → /admin no debe abrirse si no eres admin. En WhatsApp: menú numérico desde otro número.",
          "From another account: /start → try buy (cancel) → full menu → /admin must not open if not admin. On WhatsApp: menu from another number.",
          "De outra conta: /start → tentar comprar → menu · /admin não abre se não for admin."
        ),
        band(50, 12)
      ),
    ]
  ),
];

export const botWalkMarks = {
  shop: [band(22, 8), band(30, 8), band(10, 10)],
  whatsapp: [band(20, 14), band(36, 12), band(50, 12)],
  options: [band(38, 7), band(45, 7), band(52, 10)],
  identity: [band(62, 8), band(70, 12)],
  admins: [band(78, 8), band(86, 8), band(94, 8)],
  welcome: [band(55, 18)],
  "customer-menu": [band(18, 14, 6, 88), band(36, 40, 6, 88)],
  "customer-buy": [band(14, 12, 6, 88), band(30, 42, 6, 88)],
  "customer-account": [band(18, 14, 6, 88), band(36, 40, 6, 88)],
  "tg-admin": [band(14, 16, 5, 90), band(34, 36, 5, 90)],
  "tg-custom": [band(14, 14, 5, 90), band(32, 34, 5, 90)],
  "tg-texts": [band(12, 12, 5, 90), band(28, 48, 5, 90)],
  "tg-buttons": [band(12, 12, 5, 90), band(28, 52, 5, 90)],
  "tg-campaigns": [band(12, 18, 5, 90), band(40, 28, 5, 90)],
  "tg-chats": [band(12, 16, 5, 90), band(34, 40, 5, 90)],
  "tg-audience": [band(14, 40, 5, 90)],
  "tg-promos": [band(12, 16, 5, 90), band(30, 44, 5, 90)],
  "tg-promo-msgs": [band(14, 16, 5, 90), band(36, 30, 5, 90)],
  check: [band(18, 12), band(34, 12), band(50, 12)],
};

/** Índice del manual en la pestaña Bot (abre el walk en ese paso). */
export const botManualIndex = [
  { startId: "shop", title: "1. Canales WhatsApp / Telegram", hint: "Encender el bot en cada canal + TMDB" },
  { startId: "whatsapp", title: "2. Bot de WhatsApp", hint: "Conexión, menú numérico y alertas" },
  { startId: "options", title: "3. Opciones del menú", hint: "PROMO, menú guiado, monedero, calificación" },
  { startId: "identity", title: "4. Nombre y token", hint: "Tienda + @BotFather + probar" },
  { startId: "admins", title: "5. Admin y departamentos", hint: "Alertas y quién abre /admin" },
  { startId: "welcome", title: "6. Bienvenida", hint: "Primer mensaje y media" },
  { startId: "customer-menu", title: "7. Menú del cliente", hint: "Comandos y botones" },
  { startId: "customer-buy", title: "8. Compra paso a paso", hint: "Catálogo → pago → entrega" },
  { startId: "customer-account", title: "9. Servicios y soporte", hint: "Renovar, códigos, saldo, puntos" },
  { startId: "tg-admin", title: "10. Panel /admin (Telegram)", hint: "Cómo entrar al panel del bot" },
  { startId: "tg-custom", title: "11. Personalización", hint: "Menú: mensajes, botones, productos" },
  { startId: "tg-texts", title: "12. Mensajes editables", hint: "Las 14 plantillas una a una" },
  { startId: "tg-buttons", title: "13. Botones editables", hint: "Cada botón del menú" },
  { startId: "tg-campaigns", title: "14. Campañas", hint: "Aviso manual a usuarios o grupos" },
  { startId: "tg-chats", title: "15. Grupos, canales y temas", hint: "Destinos 🤖 / 👤 y foros" },
  { startId: "tg-audience", title: "16. Audiencia", hint: "Alcance antes de enviar" },
  { startId: "tg-promos", title: "17. Promos automáticas", hint: "Stock, nuevos, destacado, canales" },
  { startId: "tg-promo-msgs", title: "18. Mensajes promocionales", hint: "Avisos repetidos + opt-out" },
  { startId: "check", title: "19. Lista de cierre", hint: "Comprobar antes de publicar" },
];
